import Vue from 'vue'
import VueResource from 'vue-resource'
import api from './apiBridge'
import App from './components/App'
import router from './router'
import VueTheMask from 'vue-the-mask'
import VueI18n from 'vue-i18n'
import VueObserveVisibility from 'vue-observe-visibility'

Vue.use(VueObserveVisibility);
Vue.use(VueTheMask);
Vue.use(VueI18n);

Vue.config.productionTip = false

console.log('launch');

// test to see if running in iOS app sandbox
if (window.location && window.location.protocol == 'file:') {
  // set to use native
  api.useProxyApi = false;
} else {
  // set to use proxy API
  api.useProxyApi = true;
}

// element.path polyfill
if (!("path" in Event.prototype))
Object.defineProperty(Event.prototype, "path", {
  get: function() {
    var path = [];
    var currentElem = this.target;
    while (currentElem) {
      path.push(currentElem);
      currentElem = currentElem.parentElement;
    }
    if (path.indexOf(window) === -1 && path.indexOf(document) === -1)
      path.push(document);
    if (path.indexOf(window) === -1)
      path.push(window);
    return path;
  }
});



const i18n = new VueI18n({
  locale: 'EN',
  fallbackLocale: 'EN',
  messages: {
    "EN": {
      "login": "Login",
      "logout": "Logout",
      "reload": "Reload",
      "enter_store_number": "Enter Store Number to Login",
      "store_number": "Store Number",
      "build_version": "Build",
      "native_version": "Version",
      "ip_address": "IP Address",
      "name": "Name",
      "prev": "Prev",
      "next": "Next",
      "bump_order": "Bump Order",
      "ready": "Ready",
      "ready_orders": "Ready Orders",
      "kds_orders": "KDS Orders",
      "recall": "Recall",
      "back": "Back",
      "recall_order": "Recall Order",
      "no_orders": "No Orders",
      "no_recall_orders": "No Orders to Recall",
      "no_pending_orders": "No Pending Orders",
      "remaining": "Remaining",
      "loading": "Loading",
      "connection_error": "Connection Error",
      "no_internet": "No Internet Connection",
      "mobile_app_pickup": "Mobile App Pickup",
      "delivery_pickup": "Delivery Pickup",
      "prep": "Cooking",
      "ready": "Ready to Go!",
      "cashier": "Visit Counter"
    },
    "FR": {
      "login": "Connexion",
      "logout": "Se déconnecter",
      "reload": "Recharger",
      "name": "Nom",      
      "enter_store_number": "Entrez le numéro du magasin pour vous connecter",
      "store_number": "Numéro de restaurant",
      "build_version": "Construction",
      "native_version": "Version",
      "ip_address": "Adresse IP",
      "prev": "Préc",
      "next": "Suiv",
      "bump_order": "Passer Ordre",
      "ready": "Prêt",
      "ready_orders": "Commandes prêtes",
      "recall": "Rappel",
      "back": "Retour",
      "recall_order": "Rappel Ordre",
      "no_orders": "Pas de commande",
      "no_recall_orders": "Aucun ordre de rappel",
      "no_pending_orders": "Pas de commande",
      "remaining": "Temps Restant",
      "loading": "Chargement",
      "connection_error": "Erreur de connexion",
      "no_internet": "Pas de connexion Internet",
      "mobile_app_pickup": "Pour l'appli mobile",
      "delivery_pickup": "Pour livraison",
      "prep": "Être cuit",
      "ready": "Prêt à partir!",
      "cashier": "Voir la caisse"

    }    
  }
});

new Vue({
  el: '#app',
  i18n,
  router,
  render: h => h(App)
})




// WEBPACK FOOTER //
// ./src/main.js